"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("./styles");

var _excluded = ["children", "className", "label", "leftIcon"];

var Chevron = function Chevron(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.8644 1.45876L15.1774 0.735599C14.9966 0.554808 14.7073 0.554808 14.5627 0.735599L8.01808 7.28023L1.43729 0.735599C1.29266 0.554808 1.00339 0.554808 0.822599 0.735599L0.135593 1.45876C-0.0451977 1.6034 -0.0451977 1.89266 0.135593 2.07345L7.69266 9.63052C7.87345 9.81131 8.12655 9.81131 8.30734 9.63052L15.8644 2.07345C16.0452 1.89266 16.0452 1.6034 15.8644 1.45876Z"
  }));
};

Chevron.defaultProps = {
  viewBox: "0 0 16 10",
  xmlns: "http://www.w3.org/2000/svg"
};

var Accordion = function Accordion(_ref) {
  var children = _ref.children,
      className = _ref.className,
      label = _ref.label,
      leftIcon = _ref.leftIcon,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var handleClick = function handleClick() {
    return setIsOpen(!isOpen);
  };

  var fieldClassNames = [className];

  if (isOpen) {
    fieldClassNames.push("accordion-open");
  }

  return /*#__PURE__*/_react.default.createElement(_styles.Wrapper, Object.assign({
    className: fieldClassNames.join(' ')
  }, rest), /*#__PURE__*/_react.default.createElement(_styles.Header, {
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_styles.Label, {
    size: "body02"
  }, leftIcon && /*#__PURE__*/_react.default.createElement(_styles.Icon, null, leftIcon), label, /*#__PURE__*/_react.default.createElement(_styles.Icon, {
    className: "right"
  }, /*#__PURE__*/_react.default.createElement(Chevron, null)))), /*#__PURE__*/_react.default.createElement(_styles.Content, null, children));
};

var _default = Accordion;
exports.default = _default;